import { TodayCallbackRowView } from '../types'
import { ContactLink, Customer, LateBadge, OutcomeBadge, Phone, Row, RowHeader, Time } from './styled-components'

type TodayCallbackRowProps = Omit<TodayCallbackRowView, 'id'>

const TodayCallbackRow = ({
  time,
  customer,
  phone,
  isLate,
  lateLabel,
  outcomeLabel,
  hasContact,
  openContactLabel,
  onOpenContact,
}: TodayCallbackRowProps) => (
  <Row $isLate={isLate} data-testid='today-callback-row'>
    <RowHeader>
      <Time>{time}</Time>
      <LateBadge hidden={!isLate}>{lateLabel}</LateBadge>
      <OutcomeBadge hidden={!outcomeLabel}>{outcomeLabel}</OutcomeBadge>
    </RowHeader>
    <Customer hidden={!customer}>{customer}</Customer>
    <Phone hidden={!phone}>{phone}</Phone>
    <ContactLink type='button' hidden={!hasContact} onClick={onOpenContact}>
      {openContactLabel}
    </ContactLink>
  </Row>
)

export default TodayCallbackRow
